"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var filter_actions_1 = require("../actions/filter_actions");
var initialState = {
    etrfFilters: null
};
var filtersReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case filter_actions_1.FILTER_ACTIONS.ETRF_FILTERS:
            return __assign(__assign({}, state), { etrfFilters: action.payload });
        default:
            return state;
    }
};
exports.default = filtersReducer;
